import { createFileRoute } from "@tanstack/react-router";
import { Handshake } from "lucide-react";
import UnderConstruction from "@/components/common/UnderConstruction";

export const Route = createFileRoute("/_app/ventes/crm/$id/view")({
  staticData: {
    title: "Détails Contact",
    icon: Handshake,
    showInBreadcrumb: true,
  },
  component: UnderConstruction,
});
